import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const steps = [
  {
    num: "01",
    icon: "ri-discuss-line",
    title: "Discovery",
    desc: "We take the time to understand your business, your customers, and your goals. No jargon, no templates — just a clear plan tailored to you.",
  },
  {
    num: "02",
    icon: "ri-artboard-line",
    title: "Design",
    desc: "We design a modern, conversion-focused layout that reflects your brand. You review and approve everything before we build a single page.",
  },
  {
    num: "03",
    icon: "ri-code-s-slash-line",
    title: "Build",
    desc: "We build your site with clean code, fast load speeds, and SEO baked in from the start. Mobile-friendly, responsive, and ready to rank.",
  },
  {
    num: "04",
    icon: "ri-rocket-line",
    title: "Launch & Grow",
    desc: "We launch your site and don&apos;t just disappear. We monitor performance, rankings, and leads so your digital presence keeps growing.",
  },
];

export default function ProcessSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="section-pad bg-slate-50" ref={ref}>
      <div className="container-md">
        <div
          className={`text-center mb-14 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="text-accent text-xs font-semibold uppercase tracking-[0.2em] mb-4 block">
            How it works
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-zinc-900">
            Simple, stress-free process
          </h2>
          <p className="text-zinc-500 mt-4 max-w-xl mx-auto text-base">
            We&apos;ve worked with hundreds of small business owners. We&apos;ve made the process as simple and painless as possible.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div
              key={step.num}
              className={`relative rounded-2xl bg-white border border-zinc-200 p-7 transition-all duration-500 hover:border-accent/40 hover:bg-orange-50/20 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${i * 130}ms` }}
            >
              {/* Connector line */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 -right-3 w-6 h-px bg-accent/30 z-10" />
              )}

              <div className="font-heading text-5xl font-bold text-accent/20 mb-4 leading-none">
                {step.num}
              </div>
              <div className="w-10 h-10 flex items-center justify-center bg-accent/10 rounded-lg mb-4">
                <i className={`${step.icon} text-xl text-accent`} />
              </div>
              <h3 className="font-heading text-xl font-bold text-zinc-900 mb-3">{step.title}</h3>
              <p
                className="text-zinc-500 text-sm leading-relaxed"
                dangerouslySetInnerHTML={{ __html: step.desc }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
